import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static values = {
        //menu: Array,
    }
    connect() {
        const html = document.documentElement;
        const header = this.element;
        const mobileMenuToggle = header.querySelector('#mobileMenuToggle');
        const mobileMenu = header.querySelector('#mobileMenu');
        if (mobileMenuToggle) {
            mobileMenuToggle.addEventListener('click', (e) => {
                mobileMenu.classList.toggle('mobile-menu-active');
                html.toggleAttribute('mobile-nav-active');
                mobileMenuToggle.toggleAttribute('mobile-nav-active');
            });
        }
    }
}
